"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HSGT_GGTHot = exports.BK_HYHotLinks = exports.BK_DYHotLinks = exports.BK_GNHotLinks = exports.SZZSHotLinks = exports.BStockHotLinks = exports.SZ_HKHotLinks = exports.SH_HKHotLinks = exports.KCBHotLinks = exports.NewStockHotLinks = exports.SZHotLinks = exports.SHHotLinks = exports.HSJHotLinks = void 0;
var react_1 = __importDefault(require("react"));
require("./hotlinks.less");
var web_1 = require("../../config/web");
/**
 * 沪深京热门链接
 * @returns
 */
function HSJHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html" }, "\u5B9E\u65F6\u8D44\u91D1\u6D41\u5411"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/list.html" }, "\u4E3B\u529B\u6392\u540D"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/" }, "\u677F\u5757\u8D44\u91D1"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/hy.html" }, "\u884C\u4E1A\u8D44\u91D1\u6D41\u5411"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/gn.html" }, "\u6982\u5FF5\u8D44\u91D1\u6D41\u5411"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/dy.html" }, "\u5730\u57DF\u8D44\u91D1\u6D41\u5411"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/jlr.html" }, "\u8D44\u91D1\u6D41\u76D1\u6D4B"))));
}
exports.HSJHotLinks = HSJHotLinks;
/**
 * 上证热门链接
 * @returns
 */
function SHHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html#sha" }, "\u6CAAA\u8D44\u91D1\u6D41\u4ECA\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html#sha_5" }, "\u6CAAA\u8D44\u91D1\u6D415\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html#sha_10" }, "\u6CAAA\u8D44\u91D1\u6D4110\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/list.html#sha" }, "\u6CAAA\u4E3B\u529B\u6392\u540D"))));
}
exports.SHHotLinks = SHHotLinks;
/**
 * 深证热门链接
 * @returns
 */
function SZHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html#sza" }, "\u6DF1A\u8D44\u91D1\u6D41\u4ECA\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html#sza_5" }, "\u6DF1A\u8D44\u91D1\u6D415\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html#sza_10" }, "\u6DF1A10\u65E5\u8D44\u91D1\u6D41\u5411\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/list.html#sza" }, "\u6DF1A\u4E3B\u529B\u6392\u540D"))));
}
exports.SZHotLinks = SZHotLinks;
/**
 * 新股热门链接
 * @returns
 */
function NewStockHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//stock.eastmoney.com/newstock.html" }, "\u65B0\u80A1\u9891\u9053"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/xg/xg/default.html" }, "\u65B0\u80A1\u7533\u8D2D"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/xg/xg/calendar.html" }, "\u65B0\u80A1\u65E5\u5386"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/xg/gh/default.html" }, "\u65B0\u80A1\u4E0A\u4F1A"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/xg/xg/sbqy.html" }, "\u9996\u53D1\u7533\u62A5\u4FE1\u606F"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/xg/xg/chart/fxsyl.html" }, "\u65B0\u80A1\u89E3\u6790"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/xg/xg/dxsyl.html" }, "\u6253\u65B0\u6536\u76CA\u7387"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zrz/dxzf.html" }, "\u589E\u53D1"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zrz/pg.html" }, "\u914D\u80A1"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/xg/kzz/default.html" }, "\u53EF\u8F6C\u503A"))));
}
exports.NewStockHotLinks = NewStockHotLinks;
/**
 * 科创板热门链接
 * @returns
 */
function KCBHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//stock.eastmoney.com/kechuangban.html" }, "\u79D1\u521B\u677F\u9891\u9053"),
            "|",
            react_1.default.createElement("a", { href: "//stock.eastmoney.com/a/ckcbdd.html" }, "\u79D1\u521B\u677F\u5BFC\u8BFB"),
            "|",
            react_1.default.createElement("a", { href: "//stock.eastmoney.com/xuexiao.html?id=kcb" }, "\u79D1\u521B\u677F\u5B66\u6821"),
            "|",
            react_1.default.createElement("a", { href: "./kcb.html" }, "\u79D1\u521B\u677F\u6982\u5FF5\u80A1"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/kcb/" }, "\u79D1\u521B\u677F\u6570\u636E"),
            "|",
            react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,kcb.html" }, "\u79D1\u521B\u677F\u5427"),
            "|",
            react_1.default.createElement("a", { href: "//baike.eastmoney.com/item/%E7%A7%91%E5%88%9B%E6%9D%BF%E5%BC%80%E6%88%B7%E6%8C%87%E5%8D%97" }, "\u79D1\u521B\u677F\u5F00\u6237\u6307\u5357"))));
}
exports.KCBHotLinks = KCBHotLinks;
/**
 * 沪股通热门链接
 * @returns
 */
function SH_HKHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "./gridlist.html#ah_comparison" }, "AH\u80A1\u6BD4\u4EF7"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#sz_hk_board" }, "\u6DF1\u80A1\u901A(\u6E2F>\u6DF1)"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#hk_sh_stocks" }, "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#hk_sz_stocks" }, "\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html" }, "\u6CAA\u6DF1\u6E2F\u901A\u8D44\u91D1\u6D41\u5411"),
            "|",
            react_1.default.createElement("a", { href: "https://data.eastmoney.com/hsgtV2/hsgtDetail/sdcjg.html" }, "\u6CAA\u6DF1\u6E2F\u901A\u5341\u5927\u6210\u4EA4\u80A1"))));
}
exports.SH_HKHotLinks = SH_HKHotLinks;
/**
 * 深股通热门链接
 * @returns
 */
function SZ_HKHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "./gridlist.html#ah_comparison" }, "AH\u80A1\u6BD4\u4EF7"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#sh_hk_board" }, "\u6CAA\u80A1\u901A(\u6E2F>\u6CAA)"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#hk_sh_stocks" }, "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#sz_hk_board" }, "\u6DF1\u80A1\u901A(\u6E2F>\u6DF1)"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#hk_sz_stocks" }, "\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html" }, "\u6CAA\u6DF1\u6E2F\u901A\u8D44\u91D1\u6D41\u5411"),
            "|",
            react_1.default.createElement("a", { href: "https://data.eastmoney.com/hsgtV2/hsgtDetail/sdcjg.html" }, "\u6CAA\u6DF1\u6E2F\u901A\u5341\u5927\u6210\u4EA4\u80A1"))));
}
exports.SZ_HKHotLinks = SZ_HKHotLinks;
/**
 * B股通热门链接
 * @returns
 */
function BStockHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//stock.eastmoney.com/bgu.html" }, "B\u80A1\u9891\u9053"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#ab_comparison_sh" }, "\u6CAA\u5E02AB\u80A1\u6BD4\u4EF7\u8868"),
            "|",
            react_1.default.createElement("a", { href: "./gridlist.html#ab_comparison_sz" }, "\u6DF1\u5E02AB\u80A1\u6BD4\u4EF7\u8868"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/detail.html" }, "B\u80A1\u8D44\u91D1\u6D41\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/list.html" }, "B\u80A1\u4E3B\u529B\u6392\u540D"))));
}
exports.BStockHotLinks = BStockHotLinks;
/**
 * 沪深京指数-深证系列指数热门链接
 * @returns
 */
function SZZSHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/dpzjlx.html" }, "\u4E24\u5E02\u8D44\u91D1\u6D41"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/zs000001.html" }, "\u6CAA\u5E02\u8D44\u91D1\u6D41"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/zs399001.html" }, "\u6DF1\u5E02\u8D44\u91D1\u6D41"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/zs399006.html" }, "\u521B\u4E1A\u677F\u8D44\u91D1\u6D41"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/zs000003.html" }, "\u6CAAB\u8D44\u91D1\u6D41"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/zjlx/zs399003.html" }, "\u6DF1B\u8D44\u91D1\u6D41"))));
}
exports.SZZSHotLinks = SZZSHotLinks;
/**
 * 沪深京板块-概念
 * @returns
 */
function BK_GNHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/gn.html" }, "\u6982\u5FF5\u677F\u5757\u8D44\u91D1\u6D41\u4ECA\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/gn_5.html" }, "\u6982\u5FF5\u677F\u5757\u8D44\u91D1\u6D415\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/gn_10.html" }, "\u6982\u5FF5\u677F\u5757\u8D44\u91D1\u6D4110\u65E5\u6392\u884C"))));
}
exports.BK_GNHotLinks = BK_GNHotLinks;
/**
 * 沪深京板块-地域
 * @returns
 */
function BK_DYHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/dy.html" }, "\u5730\u57DF\u677F\u5757\u8D44\u91D1\u6D41\u4ECA\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/dy_5.html" }, "\u5730\u57DF\u677F\u5757\u8D44\u91D1\u6D415\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/dy_10.html" }, "\u5730\u57DF\u677F\u5757\u8D44\u91D1\u6D4110\u65E5\u6392\u884C"))));
}
exports.BK_DYHotLinks = BK_DYHotLinks;
/**
 * 沪深京板块-行业
 * @returns
 */
function BK_HYHotLinks() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "//stock.eastmoney.com/hangye.html" }, "\u884C\u4E1A\u9891\u9053"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/hy.html" }, "\u884C\u4E1A\u677F\u5757\u8D44\u91D1\u6D41\u4ECA\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/hy_5.html" }, "\u884C\u4E1A\u677F\u5757\u8D44\u91D1\u6D415\u65E5\u6392\u884C"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/hy_10.html" }, "\u884C\u4E1A\u677F\u5757\u8D44\u91D1\u6D4110\u65E5\u6392\u884C"))));
}
exports.BK_HYHotLinks = BK_HYHotLinks;
/**
 * 沪深港通港股通hot
 */
function HSGT_GGTHot() {
    return (react_1.default.createElement("div", { className: "hotlinks" },
        react_1.default.createElement("span", { className: "title" }, "\u70ED\u95E8"),
        react_1.default.createElement("span", { className: "links" },
            react_1.default.createElement("a", { href: "".concat(web_1.routerPrefix, "/gridlist.html#ah_comparison") }, "AH\u80A1\u6BD4\u4EF7"),
            "|",
            react_1.default.createElement("a", { href: "".concat(web_1.routerPrefix, "/gridlist.html#sh_hk_board") }, "\u6CAA\u80A1\u901A(\u6E2F>\u6CAA)"),
            "|",
            react_1.default.createElement("a", { href: "".concat(web_1.routerPrefix, "/gridlist.html#sz_hk_board") }, "\u6DF1\u80A1\u901A(\u6E2F>\u6DF1)"),
            "|",
            react_1.default.createElement("a", { href: "".concat(web_1.routerPrefix, "/gridlist.html#hk_sh_stocks") }, "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)"),
            "|",
            react_1.default.createElement("a", { href: "".concat(web_1.routerPrefix, "/gridlist.html#hk_sz_stocks") }, "\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)"),
            "|",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html" }, "\u6CAA\u6DF1\u6E2F\u901A\u8D44\u91D1\u6D41\u5411"),
            "|",
            react_1.default.createElement("a", { href: "https://data.eastmoney.com/hsgtV2/hsgtDetail/sdcjg.html" }, "\u6CAA\u6DF1\u6E2F\u901A\u5341\u5927\u6210\u4EA4\u80A1"))));
}
exports.HSGT_GGTHot = HSGT_GGTHot;
